

















































import {Vue, Component} from 'vue-property-decorator';
import CheckBoxElement from '@/components/common/CheckBoxElement.vue';
import { YorN } from 'ncp-api-supporter';

@Component({
  components: {
    CheckBoxElement
  }
})
export default class PromotionsChange extends Vue {
  private readonly mallProductNos = this.$route.params.mallProductNos;
  private readonly checkboxOptions = {
    brackets: true,
    name: 'promotionsOptions',
    data: [
      {
        id: 'additionalDiscountYn',
        value: 'additionalDiscountYn',
        dispaly: this.trans('ADDITIONAL_DISCOUNT'),
      },
      {
        id: 'couponYn',
        value: 'couponYn',
        dispaly: this.trans('COUPON'),
      },
      {
        id: 'freeGiftYn',
        value: 'freeGiftYn',
        dispaly: this.trans('FREE_GIFT'),
      },
    ]
  }
  private promotionYn: 'DIFF' | 'Y' | 'N' = 'DIFF';
  private promotionValue = 'additionalDiscountYn,freeGiftYn,couponYn';

  private trans(text: string) {
    return this.$t('PRODUCT_POP_PRODUCTLIST_' + text);
  }

  private async save() {
    if (this.promotionYn === 'DIFF') {
      alert(this.trans('PLEASE_ENTER_A_VALUE'));

      return;
    }

    const checkValue = (value: string) => this.promotionValue.split(',').includes(value) ? 'Y' : 'N'

    const { data } = await this.$api.patchProducts({
      params: {
        mallProductNos: this.mallProductNos,
      },
      data: {
        promotionInfo: {
          promotionYn: this.promotionYn as YorN,
          additionalDiscountYn: checkValue('additionalDiscountYn'),
          freeGiftYn: checkValue('freeGiftYn'),
          couponYn: checkValue('couponYn'),
        }
      },
    })

    if (data.failures && data.failures.length) {
       alert(data.failures[0].message);

       return;
    }

    alert(this.$t('PRODUCT_PRODUCTLIST_PLM_IT_IS_CHANGED'));
    opener.postMessage({ promotionsChange: true, data });
    this.close();
  }

  private close() {
    close();
  }

  private created() {
    document.body.classList.add('popup');
  }
}
